import { AxiosResponse } from 'axios';
import { eolsBaseApi, withApiErrorLoggingOnly } from '../../utilities/api.utilities';
import {
  LiteCourseSectionDto,
  MigrationStatusDTO
} from './eols-course-management-service.dtos';
import { CatalogEvolveResourceExternalEntityDtoParsed } from '../sherpath-course-management-service/sherpath-course-management-service.dtos';

export const fetchCourseSection = (selectedCourseSectionId: string): Promise<AxiosResponse<LiteCourseSectionDto>> => {
  return eolsBaseApi.get<LiteCourseSectionDto>(`/coursePlanning/courseSections/${selectedCourseSectionId}`);
};

export const fetchCoursewareMigrationStatus = (courseSectionId: string): Promise<MigrationStatusDTO> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/sherpath/course-management/courseSections/${courseSectionId}/migration/status`);
  });
};

export const updateCourseSection = (courseSectionId: string, updatedCourseInfo: Partial<LiteCourseSectionDto>, etag: string): Promise<LiteCourseSectionDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.put<LiteCourseSectionDto>(`/coursePlanning/courseSections/${courseSectionId}`, {
      data: updatedCourseInfo,
      headers: {
        'If-Match': etag
      }
    });
  });
};

export const ltiToolLaunch = (evolveResource: CatalogEvolveResourceExternalEntityDtoParsed): Promise<{ launchUrl: string; data: unknown }> => {

  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post('/sherpath/course-management/coursewareobjects/integration', {
      data: {
        title: evolveResource._parsedData.title,
        type: evolveResource._parsedData.type,
        toolName: evolveResource._parsedData.toolName,
        permission: evolveResource._parsedData.permission,
        linkUrl: evolveResource._parsedData.linkUrl,
        assetType: evolveResource._parsedData.assetType,
        resourceId: evolveResource.entity.vtwId,
      }
    });
  });

};
